module.exports = __webpack_public_path__ + "static/img/建筑智能化_建筑智能化1@2x.d959cbc.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/buliding/建筑智能化_建筑智能化1@2x.jpeg
// module id = cSEs
// module chunks = 1